// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as BlockComponent} from './Block.svg';

import Icon, { TIconProps } from '../Icon';

export const IconBlock = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <BlockComponent/>
  </Icon>
));
